export { CookiesConsentSimple, CookiesConsentSimpleWithStyles } from './CookiesConsentSimple'
